import { Injectable } from '@angular/core';
import { FacebookMeta, NameMetaTag, PropertyMetaTag, SocialMediaData, SocialTagConfig, TwitterMeta } from '../domain';

@Injectable({
  providedIn: 'root',
})
export class SocialMetaTagsService {
  public getSocialMetaDataTags(config: Partial<SocialTagConfig>, data: SocialMediaData): Array<NameMetaTag | PropertyMetaTag> {
    const twitter = this.generateTwitterTags(config.twitter, data);
    const facebook = this.generateFacebookTags(config.facebook, data);
    return [...twitter, ...facebook];
  }

  public getFacebookMeta(meta: FacebookMeta): PropertyMetaTag[] {
    return [['type', 'article'], ...Object.entries(meta)]
      .filter(([_, v]) => Boolean(v))
      .map(([k, content]) => ({ property: `og:${k}`, content }));
  }

  public getTwitterMeta(meta: TwitterMeta): NameMetaTag[] {
    return Object.entries(meta)
      .filter(([_, v]) => Boolean(v))
      .map(([k, content]) => ({ name: `twitter:${k}`, content }));
  }

  private generateTwitterTags(overrides: Partial<TwitterMeta> | false = {}, data: SocialMediaData): NameMetaTag[] {
    if (overrides === false) {
      return [];
    }

    const { title, description, image } = data;

    const defaults: Pick<TwitterMeta, 'card'> = {
      card: 'summary',
    };

    const properties = { ...defaults, title, description, image, ...overrides };

    return this.getTwitterMeta(properties);
  }

  private generateFacebookTags(overrides: Partial<FacebookMeta> | false = {}, data: SocialMediaData): PropertyMetaTag[] {
    if (overrides === false) {
      return [];
    }

    return this.getFacebookMeta({ ...data, ...overrides });
  }
}
